import { useMemo } from 'react';
import { Maybe } from '@aibees/shared/definition';
import useTransferListStore from '@aibees/shared/features/transfer-list/store/transfer-list-store';
import { TableLayoutTemplateItem } from '../types';

export function useCompareInternalTemplateChanges(
  internalTemplateEditItem: Maybe<TableLayoutTemplateItem>
) {
  const { included, excluded } = useTransferListStore();

  const hasInternalTemplateChanges = useMemo(() => {
    if (!internalTemplateEditItem) return false;

    const arraysEqual = (arr1: string[] = [], arr2: string[] = []) => {
      if (arr1.length !== arr2.length) return false;
      const sorted1 = [...arr1].sort();
      const sorted2 = [...arr2].sort();
      return sorted1.every((val, index) => val === sorted2[index]);
    };

    const includedChanged = !arraysEqual(
      included,
      internalTemplateEditItem.value.included
    );
    const excludedChanged = !arraysEqual(
      excluded,
      internalTemplateEditItem.value.excluded
    );

    return includedChanged || excludedChanged;
  }, [internalTemplateEditItem, included, excluded]);

  return hasInternalTemplateChanges;
}
